// src/modules/reports/api/index.ts
import { axiosPrivate } from "@/modules/common/api";

// Получаем список отчетов (module_selection_reports)
export async function getModuleSelectionReports(data: any) {
  // POST /api/v1/reports/all/
  const res = await axiosPrivate.post(`/api/v1/reports/all/`, data);
  return res;
}

// Получаем список уникальных forge_model_id
export async function getUniqueForgeModelIds() {
  // GET /api/v1/reports/unique/
  const res = await axiosPrivate.get(`/api/v1/reports/unique/`);
  return res;
}
